<template></template>

<script>
import { MapeventBus } from "../../util/MapEventBus";
import { surveillenceEventBus } from "../../util/surveillenceEventBus";
import { DeviceEventBus } from "../../DeviceEventBus";
import {FollowTarget } from "../../store/EventBus/FollowTargetEB"
import _ from "lodash";
import * as turf from "@turf/turf";
import sizeof from "object-sizeof";
import { setInterval, clearInterval } from "timers";
import mapboxgl from "mapbox-gl/dist/mapbox-gl.js";
import * as util from "../../util/utility";
import * as sUtil from "../../util/surveillanceUtility";
import * as d3 from "d3";

import Vue from 'vue'
const uuidv4 = require("uuid/v4");
import {trackAircraft} from '../../test/externalFunction'



export default {
  name: "surveillanceRender",
  data() {
    return {
      map: null,
      query: null,
      markerMap: new Map(),
      requestStatus: false,
      counter: 0,
      surveillanceRequestTimer: null,

      surveillanceInterval: null,
      inactiveSurveillanceTimeOut: 30,
      dataBlock: {
        width: 60,
        height: 70
      },
      mainWindow: {
        width: 0,
        height: 0
      },
      canvas: null,
      hvctx: null, // hight volume canvas context
      keysToDelete: null,
      mapBounds: null
    };
  },
  components:{
        
    },
  methods: {
    async renderSurveillance() {
      // console.log(this.map.getCenter())
      let surData = this.$store.getters["surveillance/getSurveillanceData"];

     if(this.hvctx) this.hvctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    

      let markerKeys = new Set(this.markerMap.keys());
      let surDataKeys = new Set(surData.keys());

      //Get the keys in markerMap and not in the new data 
      this.keysToDelete = [...new Set([...markerKeys].filter(x => !surDataKeys.has(x)))];
      // console.log(this.keysToDelete)  
       if (this.keysToDelete)
        this.keysToDelete.forEach(key => {
          this.markerMap.get(key).remove();
          this.markerMap.delete(key);
        });
      this.keysToDelete = null;

      surData.forEach((value, key) => {

        let pt = turf.point([
          value.state.location.lon,
          value.state.location.lat
        ]);
        let within = turf.booleanPointInPolygon(pt, this.query.boundingBox);

        let angle = 0;
        if (value.state.velocity) {
          angle = value.state.velocity.track ? value.state.velocity.track : 0;
        }
       
        if (within) {
            // console.log("Zoom 1 :  ", this.map.getZoom());
          if (this.map.getZoom() <= 6.5) {
           
            // console.log("Started zoom level from 0 -> 5");
            let screenCoords = this.map.project([value.state.location.lon,value.state.location.lat]);
            const x = Math.round(screenCoords.x * 100) / 100;
            const y = Math.round(screenCoords.y * 100) / 100;

            this.hvctx.save();
                
              this.hvctx.lineWidth = 1;
              this.hvctx.strokeStyle = "#DAA520";
              this.hvctx.translate(x, y);
              this.hvctx.rotate((angle * Math.PI) / 180);

              this.hvctx.beginPath();
              this.hvctx.moveTo(0, -8); // (1)
              this.hvctx.lineTo(-5, 0); // (2)
              this.hvctx.lineTo(0, -2); // (3)
              this.hvctx.lineTo(5, 0); //(4)

              this.hvctx.closePath();
              this.hvctx.fillStyle = "#2055da"; //#FFFFFF";
              this.hvctx.fill();
              this.hvctx.stroke();

            this.hvctx.restore();
                
            if(value.state.acID){
              this.hvctx.save();
                this.hvctx.fillStyle = "rgba(206, 197, 197,0.8)";
                this.hvctx.fillRect(x-15,y+5,40, 10);
    
                this.hvctx.fillStyle =  "black"
                this.hvctx.strokeStyle = "black"; 
                this.hvctx.font = "`5`px Arial";
                this.hvctx.textBaseline = "top";  
                this.hvctx.fillText(value.state.acID, x-15,y+5)

              this.hvctx.restore();
            }

          } else {
            if (this.markerMap.has(key)) {
              // console.log("update: ",key)
              this.markerMap.get(key).setLngLat([value.state.location.lon,value.state.location.lat])
              let canvas = this.markerMap.get(key).getElement()
              this.markerElement(value, canvas)
              // this.markerMap.get(key).getPopup().setHTML(this.dataBlockContent(value.state))
            } else {
              //  console.log("new: ",key)
              let mele = this.markerElement(value);
              let marker = new mapboxgl.Marker({element: mele,offset: { x: -0, y: -0 },anchor: "center"})
              marker.setLngLat([value.state.location.lon,value.state.location.lat])
              let popup = new mapboxgl.Popup({ offset: [0, 0] })
              let content_string = this.dataBlockContent(value.state)
              popup.setHTML(content_string)
              marker.setPopup(popup)
              marker.addTo(this.map)
              this.markerMap.set(key, marker)

              popup.on('open', e => {
                
                  // console.log('popup open ' ,e);
                  // console.log( e.target._content.innerHTML)
                  // var popUps = document.getElementsByClassName('mapboxgl-popup');
                  // console.log(popUps[0].innerHTML)
                  // let ele= document.getElementById(`trackACID_${value.state.icao.address}`)
                  // console.log(ele)
                  // ele.addEventListener("click", trackAircraft(`trackACID_${value.state.icao.address}`))

              });
              popup.on('close', e => {
                // console.log('popup close ' ,e);

              });
              // let div = document.createElement('div');
              // div.innerHTML = content_string.trim();
             
              // popup.setDOMContent (div)
              // popup.setHTML(div);
    
              window.trackAircraft = () => {
                console.log('Button clicked' ,value.state.icao.address);
              };
              window.followAircraft = (id)=>{
                // console.log("followAircraft ---> ", id)
                // var popUps = document.getElementsByClassName('mapboxgl-popup');
                // let ele= document.getElementById(`followID_${value.state.icao.address}`)
                // console.log(ele)
                // console.log(popUps[0].innerHTML)
                //  console.log("Requesting follow ", id)
                FollowTarget.$emit("followTarget",{id})
               
              }
             
            }
          } //end if zoom > 5
        } //end if within bbounding area 
       
      }); //end looping through all the data

     
    },
    removeAll() {
      // console.log("removeAll")
      if(this.hvctx) this.hvctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      // if (this.map.getZoom() <= 6.5)
      {
        this.markerMap.forEach((value, key) => {
          this.markerMap.get(key).remove();
          this.markerMap.delete(key);
        });
      }

      clearInterval(this.surveillanceRequestTimer);
      this.surveillanceRequestTimer = null;
      // this.generateRequest()
    },
    removeState(id) {
      // console.log("removeState ",id)
      if (this.markerMap.has(id)) {
        this.markerMap.get(id).remove();
        this.markerMap.delete(id);
      }
    },
    requestSurveillance() {
      // let testBounds  = this.map.getBounds()
      // console.log(!_.isEqual(testBounds,this.mapBounds))
      // if(!_.isEqual(testBounds,this.mapBounds)){
      //     console.log("bounds not equal")
      //     let p1 = [testBounds._sw.lng,testBounds._sw.lat]
      //     let p2 = [testBounds._ne.lng,testBounds._ne.lat]
      //     let d1 = sUtil.distanceBetweenTowPointsMiles(p1,p2)
      //     p1 = [this.mapBounds._sw.lng,this.mapBounds._sw.lat]
      //     p2 = [this.mapBounds._ne.lng,this.mapBounds._ne.lat]
      //     let d2 = sUtil.distanceBetweenTowPointsMiles(p1,p2)
      //     let dDelta = Math.abs( d2-d1)

      //     if( dDelta>10){
      //         console.log("3-requestSurveillance-1 ")
      //         this.generateRequest()
      //     }
      // }
      // else
      {
        //  console.log("3-requestSurveillance-2 ")
        this.$store.dispatch("surveillance/getSurveillance", this.query);
        
      }
    },
    queryGenerator() {
      //    console.log("2-queryGenerator ")

      this.mapBounds = this.map.getBounds();
      let lineSwNe = turf.lineString([
        [this.mapBounds._sw.lng, this.mapBounds._sw.lat],
        [this.mapBounds._ne.lng, this.mapBounds._ne.lat]
      ]);
      let diagonal = turf.length(lineSwNe);
      let poly = turf.bboxPolygon(turf.bbox(lineSwNe));
      this.query = {
        lat: this.map.getCenter().lat,
        lon: this.map.getCenter().lng,
        radius: diagonal / 2,
        umi: "mi",
        zoom: this.map.getZoom(),
        boundingBox: poly
      };

      return this.query;
    },
    generateRequest: _.debounce(
      function() {
        // console.log("1-generateRequest")
        this.query = this.queryGenerator();
        this.requestSurveillance();
        if (this.query.zoom >= 6.5) {
          this.surveillanceInterval = 3000;
        } else {
          this.surveillanceInterval = 10000;
        }

        if (this.surveillanceRequestTimer) {
          //    console.log("1 cleared Interval for surveillanceRequestTimer")
          clearInterval(this.surveillanceRequestTimer);
        }

        this.surveillanceRequestTimer = setInterval(
          this.requestSurveillance,
          this.surveillanceInterval
        );
      },
      50,
      { leading: true, trailing: false }
    ),

    markerElement(data, canvas) {
      let angle = 0;
      if (data.state.velocity) {
        angle = data.state.velocity.track ? data.state.velocity.track : 0;
      }
      let ratio = sUtil.PIXEL_RATIO()
      if(!canvas)
      {
        canvas =sUtil.createHiDPICanvas(this.dataBlock.width ,this.dataBlock.height)
        let att = document.createAttribute("id");
        att.value = data.state.icao.address;
        canvas.setAttributeNode(att);
      }

      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      //For Testing only
      // ctx.fillStyle = "rgba(206, 197, 197,0.8)";
      // ctx.fillRect(0, 0,canvas.width,canvas.height);
      // ctx.fill();
      // ctx.stroke()

      // Draw & rotate chevron
      this.drawTriangle(ctx,canvas.width/(2*ratio ),canvas.height/(2*ratio),angle)
     
      //Draw Data Static Block
      
      this.drawStaticDatablock(ctx,canvas.width,canvas.height,ratio,data)
        
      return canvas;
    },
    drawTriangle(ctx,  cx, cy,angle){

      ctx.save();

        ctx.translate(cx,cy) 
        ctx.rotate((angle * Math.PI) / 180)
        
        ctx.lineWidth = 1
        ctx.strokeStyle = "#171616"
        ctx.fillStyle = "#cec5c5"  //"#ffffff"// 

        ctx.beginPath();
          ctx.moveTo(0, -10); // (1)
          ctx.lineTo(-8, 0); // (2)
          ctx.lineTo(0, -5); // (3)
          ctx.lineTo(10, 0); //(4)
        ctx.closePath();
      
        ctx.stroke();
        ctx.fill(); 

      ctx.restore();
      
      
    },
    drawStaticDatablock(ctx,w, h,ratio,data){
       let dbStr,isAirborn =false
      try 
      {
        ctx.save()
          //console.log(data)
          dbStr = sUtil.staticDataBlock(data)
          if(data.state.velocity){
            isAirborn = data.state.velocity.state == "AirBorn"
          }
          ctx.fillStyle = "rgba(206, 197, 197,0.5)";
          ctx.fillRect(0, w/(1.3*ratio) , h-22, h / (1.5*ratio));
          // ctx.fillRect(0,cx / (1.3 *ratio), 40, 40);
          // data.state.velocity.state == "AirBorn"
          // console.log(data )
        
          ctx.fillStyle =  "black"
          ctx.strokeStyle = "black";
          ctx.font = "`8`px Arial";
          ctx.textBaseline = "top";
          
          let txtS = dbStr.split("\n");
          ctx.fillText(txtS[0],w/10, 48);
          if(isAirborn) 
          ctx.fillText(txtS[1],w/10, 56);
      

        ctx.restore()  
      } 
      catch (error) {
        console.log("************************************")
        console.log(dbStr)
        console.log(JSON.stringify( data))
        console.log(error)
        console.log("************************************")
      }
      

    },
    dataBlockContent2(value) {
      let content = 
       `<div id="sdb" class="container-fluid">

          <div class="row" >
            <div class="col-sm" >
              <strong>ACID: </strong>
            </div>
            <div class="col-sm">
              <p>${value.acID}</p> 
            </div>
          </div>
          
          <div class="row">
            <div class="col-sm">
               <button @click="trackTest" type="button" class="btn btn-link btn-sm btn-block">Track</button>
            </div>
          </div>

        </div>`
    
      return  content;
    },
     dataBlockContent3(value) {
        let vx = new Vue({el:"#sdb",
                          data(){
                          return{
                              value
                            } 
                          }
        })
       return this.dataBlockContent2(value)
     },
    dataBlockContent(value) {
      //  console.log(JSON.stringify( value) +"\n\n")
      var content = "<div "  +'   class="dataBlock text-info">';

        // content += "<strong >icao: </strong> " + value.icao.address + "<br>" + "";

        if (typeof value.squwak != "undefined") {
          //dataBlockSettings.userDataBlock.squwak
          content += "<strong >Squawk: </strong> " + value.squwak + "<br>" + "";
        }
    
        if (typeof value.acID != "undefined") {
          
          content += "<strong>ACID: </strong> " + value.acID + "<br>" + "";
        } 
        
        if (typeof value.alt != "undefined") {
          content +="<strong>PALT: </strong>" +(typeof value.alt.pressure != "undefined"? parseInt(value.alt.pressure)+" ft": "N/A")+"<br>"+"";

          if (typeof value.alt.geometric != "undefined") {
            content +="<strong>GALT: </strong>" +parseInt(value.alt.geometric) +" ft"+"<br>"+"";
          }
        }

        if (typeof value.velocity != "undefined") {
            content +="<strong>HDG: </strong>"+Math.round( value.velocity.track) +" deg"+"<br>" +"";
            content +="<strong>SPD: </strong>" +Math.round(value.velocity.speed)+" kt"+"<br>" +"";
        }

        if(value.arr && value.dep)
        {
          content +="<strong>DEP: </strong>" +value.dep +"<br>" +"";  
          content +="<strong>ARR: </strong>" +value.arr +"<br>" +"";
        }
     
    
        content += "<div  class='' >";
        // content+=`<button onclick = "trackAircraft( )" id=trackACID_${value.icao.address}   type="button"   class="btn btn-light btn-sm">Primary</button>`
          // content += "<ul  class='list-inline center-block'>";
           content += "<hr style='margin: 0px;'>"
          //  content +=  "<a  onclick = trackAircraft() >" +"<strong>Track  </strong>" +"</font>"+"</a>" +"";
            // content +='&nbsp;|&nbsp;'
            content +='&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
            content += `<a  onclick = followAircraft("${value.icao.address}") id=followID_${value.icao.address}>` +"<strong>Follow</strong>" +"</font>"+"</a>" +"";
        
          // content += "</ul>";

          
        content += "</div>";

      return content;
    },
    onWindowResize: _.debounce(
      function() {
       // console.log(window)
        this.mainWindow.width = window.innerWidth;
        this.mainWindow.height = window.innerHeight;
        if(this.canvas )
        {
          this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        }
        //console.log("Window Resize : ",this.mainWindow.width,this.mainWindow.height)
        this.renderSurveillance();
      },
      500,
      { leading: true, trailing: false }
    ),
    createHighVolumeCtx(){

       // Start : High volume canvas setup
        this.mainWindow.width = this.map.getContainer().clientWidth//window.innerWidth;
        this.mainWindow.height =this.map.getContainer().clientHeight  //window.innerHeight;
        

        // let bbox = document.body.getBoundingClientRect();
        let container = this.map.getCanvasContainer();
        
        this.canvas = d3.select(container).append("canvas").node();
        let att = document.createAttribute("id");
        att.value =  "12345";//uuidv4()
        this.canvas.setAttributeNode(att);
        this.canvas.width = this.mainWindow.width;
        this.canvas.height = this.mainWindow.height;
        this.canvas.classList.add("mycanvas");
        this.hvctx = this.canvas.getContext("2d");
        // End : Hight volume canvas setup

        this.hvctx .fillStyle = "blue";
        this.hvctx .fillRect(0, 0, this.canvas.width, this.canvas.height);


  }
  },
  mounted() {
    // console.log("SurveillanceRender Mounted ,.... ", (new Date()).getTime());
   
    // this.$store.dispatch("surveillance/init")
    this.map = this.$store.getters["mapStore/getMap"];

   
    this.generateRequest();
    DeviceEventBus.$on("connectionStatus", status => {
      if (status.connected) {
        this.generateRequest();
      }
    });

    //  DeviceEventBus.$on("appState",(state)=>{
    //      console.log(`surveillanceRender:on:appState  ${JSON.stringify( state)} `)
    //      if(state.isActive){
    //           this.generateRequest()
    //      }

    //  })

    // setup event listeners
    // window.onresize =_.debounce(()=>{this.onWindowResize},100)
    window.addEventListener("resize", _.debounce(this.onWindowResize, 1000));

    // MapeventBus.$on("dragstart", () => {
    //   //  console.log("dragstart")
     
    // });
    MapeventBus.$on("dragend", () => {
      // console.log("Surv:dragend")
       this.removeAll();
      this.generateRequest();
    });

    // MapeventBus.$on("zoomstart", () => {
    //   //  console.log("zoomstart")
    //   // this.removeAll();
    // });
    MapeventBus.$on("zoomend", () => {
      // console.log("Surv:zoomend")
      this.removeAll();
      this.generateRequest();
    });

    MapeventBus.$on("load", () => {
      //  console.log("surveillance load")
       this.createHighVolumeCtx()
      this.generateRequest();

    });

    surveillenceEventBus.$on("UpdateSurveillanceData", this.renderSurveillance);
  },
  
  beforeDestroy() {
    console.log("beforeDestroy surveillancneRender");

    clearInterval(this.surveillanceRequestTimer);

    console.log("4surveillanceRequestTimer ", this.surveillanceRequestTimer);

    window.removeEventListener("resize", this.onWindowResize);
  }
};
</script>

<style  >
/* .mycanvas {
  position: absolute;
  width: 100%;
  height: 100%;
} */
canvas {
  position: absolute;
  /* width: 100%;
  height: 100%; */
}

</style>
